import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { textSans } from '@guardian/src-foundations/typography';
import { between } from '@guardian/src-foundations/mq';
import { formatCount } from '@root/src/web/lib/formatCount';
import CommentIcon from '@frontend/static/icons/comment.svg';
const containerStyles = (palette) => css `
	display: flex;
	align-self: flex-end;
	flex-direction: column;
	${textSans.medium()};
	font-weight: bold;
	color: ${palette.fill.commentCount};
	padding-top: 5px;
`;
const iconContainerStyles = css `
	height: 15px;
	margin: 0;
	text-align: right;
	margin-bottom: -2px;
	svg {
		height: 18px;
		width: 18px;
	}
`;
const iconStyles = (palette) => css `
	fill: ${palette.fill.commentCount};
`;
const longStyles = css `
	display: block;

	${between.leftCol.and.wide} {
		display: none;
	}
`;
const shortStyles = css `
	display: none;

	${between.leftCol.and.wide} {
		display: block;
	}
`;
const linkStyles = css `
	color: inherit;
	text-decoration: none;
	:hover {
		text-decoration: underline;
	}
	:visited {
		color: inherit;
	}
`;
export const CommentCount = ({ isCommentable, commentCount, palette, setIsExpanded, }) => {
    if (!isCommentable)
        return null;
    const { short, long } = formatCount(commentCount);
    return (_jsx("data", Object.assign({ css: containerStyles(palette), "data-cy": "comment-counts", value: `${long} comments on this article` }, { children: _jsxs("a", Object.assign({ href: "#comments", css: linkStyles, "aria-label": `${short} Comments`, onClick: () => setIsExpanded(true) }, { children: [_jsx("div", Object.assign({ css: iconContainerStyles }, { children: _jsx(CommentIcon, { css: iconStyles(palette) }, void 0) }), void 0), _jsx("div", Object.assign({ "data-testid": "long-comment-count", css: longStyles, "aria-hidden": "true" }, { children: long }), void 0), _jsx("div", Object.assign({ "data-testid": "short-comment-count", css: shortStyles, "aria-hidden": "true" }, { children: short }), void 0)] }), void 0) }), void 0));
};
